import { cn, cva, type VariantProps } from 'noddi-ui-common';
import { PropsWithChildren } from 'react';

const animateIntoViewVariants = cva('animate-in duration-500 fade-in-0', {
  variants: {
    direction: {
      fromTop: 'slide-in-from-top-4',
      fromBottom: 'slide-in-from-bottom-4',
      fromLeft: 'slide-in-from-left-4',
      fromRight: 'slide-in-from-right-4'
    }
  },
  defaultVariants: {
    direction: 'fromBottom'
  }
});

export const AnimateIntoView = ({
  children,
  className,
  direction
}: PropsWithChildren<{ className?: string } & VariantProps<typeof animateIntoViewVariants>>) => {
  return <div className={cn(animateIntoViewVariants({ direction }), className)}>{children}</div>;
};
